import React from 'react';
import { translate } from '../../../services/translate';
import { DispatchParamList } from '../../../typings/Params';
import { NavigationProp, RouteProp, useNavigation } from '@react-navigation/native';
import { useAuth } from '../../../context/Auth';
import { useForm } from 'react-hook-form';
import FilterModal from '../../../components/ModernFilters/FilterModal';
import ActingBodyList from '../../../components/ModernFilters/dispatch/ActingBodyList';

interface Props {
    filters: DispatchParamList['UnitCategories'];
    setFilters: React.Dispatch<React.SetStateAction<DispatchParamList['UnitCategories']>>;
}

function Filter({ filters, setFilters }: Props) {
    const { user: authenticatedUser } = useAuth();
    const navigation = useNavigation<NavigationProp<RouteProp<DispatchParamList, 'UnitCategories'>>>();

    type FiltersForm = {
        actingBodyId: number | null;
    };

    const form = useForm<FiltersForm>({
        mode: 'onChange',
        defaultValues: {
            actingBodyId: filters.actingBodyId ?? null,
        },
    });

    const handleFilter = () => {
        const formValues = form.getValues();

        const params = {
            actingBodyId: formValues.actingBodyId ?? undefined,
        };

        navigation.setParams({
            ...filters,
            page: 1,
            ...params,
        });

        setFilters({
            ...filters,
            page: 0,
            ...params,
        });

    };

    return (
        <FilterModal
            form={form}
            onFilters={handleFilter}
            cleanValues={{
                actingBodyId: null,
            }}
            filters={[{
                label: translate('organizational'),
                filters: [{
                    componentHandlesCount: true,
                    name: 'actingBodyId',
                    label: translate('actingBody'),
                    component: ActingBodyList,
                    omit: !(authenticatedUser?.isAdmin || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_unit_category),
                }]
            }]}
        />
    );
}

export default Filter;
